import React, { Fragment } from 'react'
import {
    Edit,
    TextInput,
    NumberInput
} from 'react-admin'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'

export const RegionEdit = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    return (
        <Fragment>
            <Title title={"Editar Región"} />
            <Edit {...props}>
                <CustomSimpleForm>
                    <NumberInput source="id" label="ID" />
                    <NumberInput source="code" label="Código" />
                    <TextInput source="name" label="Nombre" />
                    <TextInput source="full_name" label="Nombre Largo" />
                </CustomSimpleForm>
            </Edit>
        </Fragment>
    )
};
